import { render, staticRenderFns } from "./SimpleContentWithCtaButton.vue?vue&type=template&id=5da3d32e&"
import script from "./SimpleContentWithCtaButton.vue?vue&type=script&lang=js&"
export * from "./SimpleContentWithCtaButton.vue?vue&type=script&lang=js&"
import style0 from "./SimpleContentWithCtaButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports